export default __webpack_public_path__ + "static/media/deposit.6cb90d3d.svg";